module.exports = __webpack_public_path__ + "img/box2.bffe1f65.png";